import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    HostBinding,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from "@angular/core";
import { debounced } from "@spscommerce/utils";

@Component({
    selector: "sps-page-selector",
    templateUrl: "./sps-page-selector.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsPageSelectorComponent implements OnChanges {
    static readonly displayName = "sps-page-selector";
    static readonly props = {
        page: "number",
        numPages: "number",
        pageChange: { event: true, type: "number" },
    };

    private static _idNum = 0;
    _id: string;

    @HostBinding("class.sps-page-selector") readonly _spsPageSelectorClass = true;

    @Input() page = 1;
    @Output() pageChange = new EventEmitter<number>();

    @Input() numPages = 0;

    get numPagesText() {
        return Number.isNaN(this.numPages) ? "many" : this.numPages;
    }

    _inputPage: number = this.page;

    constructor(private _changeDetector: ChangeDetectorRef) {
        this._id = `sps-page-selector-${SpsPageSelectorComponent._idNum++}`;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.page) {
            this.setPage(changes.page.currentValue);
        }
    }

    setPage(newPage: number) {
        if (!newPage || newPage < 1) {
            this.page = 1;
        } else if (newPage > this.numPages) {
            this.page = this.numPages;
        } else {
            this.page = newPage;
        }
        this._inputPage = this.page;
        this._changeDetector.markForCheck();
    }

    @debounced(1000)
    _onTextInputChange() {
        const pg = this.page;
        this.setPage(Number(this._inputPage));
        if (this.page !== pg) {
            this.pageChange.emit(this.page);
        }
    }

    previousPage() {
        if (this.page > 1) {
            this.setPage(this.page - 1);
            this.pageChange.emit(this.page);
        }
    }

    nextPage() {
        if (this.page < this.numPages) {
            this.setPage(this.page + 1);
            this.pageChange.emit(this.page);
        }
    }
}
